"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
var react_1 = __importDefault(require("react"));
var NotFound = function () { return (react_1.default.createElement("div", { className: "ai-center flex flex-col px7 py7" },
    react_1.default.createElement("p", { className: "f7 fw7" }, "Oops!"),
    react_1.default.createElement("p", { className: "f5" }, "Couldn't find the page you're looking for."),
    react_1.default.createElement("p", { className: "f3" }, "This page doesn't exist or was deleted."))); };
exports.NotFound = NotFound;
